export enum StudyModes {
  Flashcards,
  MultipleChoice,
  PracticeTest
}
